module.exports = __webpack_public_path__ + "assets/img/00073.a2cc92e4.png";